<div>
  <!-- custom header? -->
  <app-header class="d-none d-xl-block"></app-header>
  <header class="profile__custom-header d-xl-none d-flex px-3 mb-2">
    <button
      class="btn btn-link f-color-dark p-0 d-flex align-items-center w-100 f-size-14"
      (click)="openNavigationModal()"
    >
      <img
        src="/assets/images/arrow-down.svg"
        class="profile__custom-header__arrow"
        alt="arrow"
      />
      {{ getGeneratedHeaderTitle ? getGeneratedHeaderTitle : "" }}
    </button>
  </header>
  <div
    class="container container__custom-width profile d-flex justify-content-between flex-xl-nowrap flex-wrap py-3 py-xl-5 px-3 px-xl-0 pr-xl-3 pr-xl-0"
  >
    <div class="profile__navbar col-xl-3 d-none d-xl-block pl-xl-0">
      <app-profile-navbar></app-profile-navbar>
    </div>
    <div class="profile__content col-xl-9 px-0">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</div>
